import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-media-math',
  templateUrl: './media-math.component.html',
  styleUrls: ['./media-math.component.scss']
})
export class MediaMathComponent extends BaseDatasourceComponent implements OnInit {

  constructor(private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      clientId: new FormControl('', [Validators.required]),
      clientSecret: new FormControl('', [Validators.required]),
    });
  }

  connect() {
    if (this.connectionForm.valid) {
      // const url = this.config.root + this.config.urls.account.saveMediaMathConfig;
      // this.common.post(url, this.connectionForm.value, (response) => {
      //   if (response.result === false) {
      //     this.openSnackBarWarning(this.snackBar, response.text, 'closed');
      //   } else {
      //     this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
      //     this.dialogRef.close();
      //   }
      // });
    }
  }
}
